import type { FaireProductEntity } from "../../entity_types/product";

export const p_pdq2dy2wuc: FaireProductEntity = {
  token: "p_pdq2dy2wuc",
  type: "product",
  name: "25-Pack Individually Wrapped Adult Disposable Face Masks",
  brandToken: "b_w6b6bvkhz4",
  brandName: "Lexi Home",
  imageUrl:
    "https://cdn.faire.com/fastly/fe5a9705869ab89dcffe41c616cc96bf0fcd7629984faf78ed7c8f436332bbd7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ed4a4b63fcd74b4a2c61136c5eedd2707834c12b66e37b726961905eb3d82adc.jpeg",
    "https://cdn.faire.com/fastly/80e896db79926e222cfdf80003811151a9f7218b54069dc0dee8643268cfb99b.jpeg",
    "https://cdn.faire.com/fastly/c9d61143c76935a5892c3819b0aa5b2f2458572620c7cd691fcae3903c0b99ec.jpeg",
    "https://cdn.faire.com/fastly/4595dbd2ad8a990365ae623545f2217be511500af9c4596810a5f742005bb5b2.jpeg",
    "https://cdn.faire.com/fastly/98690daaec17c8680ff3ee115028f283da36c6b2fc6fecf83a8a0a3d01390989.jpeg",
    "https://cdn.faire.com/fastly/7794b43c9194d283320a59cc9de73ad72323609042e1383803f56edaf28fcb1d.jpeg",
    "https://cdn.faire.com/fastly/a25e14e4b897b930b2c4fda930220f3b3130d9ca957e0de0e3bf75c928d28af8.jpeg",
  ],
  priceDollars: 6.96,
  description:
    'Lexi Home\'s non-medical disposable face masks are crafted with 3 protective layers, featuring elastic ear loops and a flexible nose wire for an ideal fit. The breathable design makes them comfortable to wear in situations where social distancing is challenging. With 3 protective layers including a soft non-woven inner layer, a melt-blown fabric middle layer, and a liquid-resistant outer layer, these masks effectively shield against airborne dust, pollen, and allergens. Each mask is individually wrapped to prevent cross-contamination.\n\nKey Features\n\nElastic Earloops: Crafted from premium elastic for enhanced comfort.\nNose Bridge Clip: Prevents the face mask from slipping off effectively.\n3-Ply: Comprising three ultra-soft layers for gentle skin contact.\nIndividually Wrapped: Each mask is individually wrapped, for on-the-go use.\nDimensions: Each face mask measures 7" x 3.75".\n\nCase Pack: 1,000 masks (20 pre-packs of 25 count packages)',
  tags: [],
  msrpDollars: 13.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T18:05:59.530Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
